import React, { Component } from "react";
import __ from "lodash";
import { cekCookies } from "../../../../../actions";
import history from "../../../../../history";
import { connect } from "react-redux";
import { CONFIG, URL_AKM } from "../../../../../config";
import accountManagement from "../../../../../apis/accountManagement";
import akmApi from "../../../../../apis/akmApi";
import { Form, Alert, Row, Col, Button, Modal } from "react-bootstrap";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import LoaderModal from "../../../../modal/LoaderModal";
import Navbar from "../../../navbar/Navbar";
import Sidebar from "../../../sidebar/Sidebar";
import DropdownMapel from "../../masterDropDown/DropdownMapel";
import { Switch, TextField } from "@material-ui/core";
import SubProfilCbt from "../../../../../entity/SubProfilCbt";
import { Autocomplete } from "@material-ui/lab";

class SetPointSbmptn extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isFetching: false,
            profil: {},
            subProfil: SubProfilCbt,
            subProfilCbtSoal: [],
            poinSoal: [],
            action: "add",
            alertShow: false,
            successAlert: false,
            resMessage: "",
            returnTo: "/mgtsbmptn",
            missingContext: false,
        };
    }

    async componentDidMount() {
        const { profil, subProfil, returnTo } = this.props.location.state || {};
        if (!profil || !subProfil || !subProfil.idSubProfilCbt) {
            this.setState({ missingContext: true });
            await this.props.cekCookies();
            return;
        }
        console.log("====================================");
        console.log("profil", profil);
        console.log("subProfil", subProfil);
        console.log("====================================");
        const profileRoutes = ["/mgttoo", "/mgtsbmptn", "/mgtagcu", "/mgtpeminatan",
            "/mgtpemetaan", "/mgtpemetaan2", "/mgtpemetaan3", "/mgtensa"];
        const origin = profileRoutes.indexOf(returnTo) >= 0 ? returnTo :
            (profil.kodeSubTipeCbt === "TRYOUT" ? "/mgttoo" : "/mgtsbmptn");
        this.setState({ isFetching: false, profil: profil, subProfil: subProfil, returnTo: origin });
        await this.props.cekCookies();
        if (!__.isEmpty(this.props.account)) {
            // this.fetchMapel();
            // this.fetchKategori();
        }
        if (!__.isEmpty(subProfil)) {
            this.setState({
                subProfil: subProfil,
                action: "edit",
            });
        }

        const result = await akmApi.get(URL_AKM.SUBPROFIL_SOAL_SBMPTN + subProfil.idSubProfilCbt).catch(function (error) {
            console.log(error);
        });

        if (result) {
            console.log("====================================");
            console.log("result", result);
            console.log("====================================");
            console.log("====================================");
            console.log("subprofil", subProfil.idProfilCbt);
            console.log("====================================");
            this.setState({ subProfilCbtSoal: result.data.data });
        }

        this.setState({ isFetching: false });
    }

    handleOnChangeNilai = async (e) => {
        const splitFirst = e.target.name.split("#_", 2);
        const splitSecond = splitFirst[1].split("_", 3);

        // console.log("====================================");
        // console.log("splitSecond", e.target.value);
        // console.log("====================================");
        // this.setState({ [e.target.name]: e.target.value });

        this.setState({
            poinSoal: [...this.state.poinSoal, { idBankSoal: splitSecond[0], idCbtSoalHub: splitSecond[1], poinSoal: e.target.value }],
        });
    };

    handleSubmit = async (e) => {
        console.clear();
        e.preventDefault();

        const dataSend = this.state.poinSoal;

        console.info("DATA SEK DIKIRIM", dataSend);

        const respSubmit = await akmApi.post(URL_AKM.SET_POIN_SBMPTN, dataSend).catch(function (error) {});

        if (respSubmit) {
            console.log("====================================");
            console.log("Save Success => ", respSubmit);
            console.log("====================================");
            this.setState({
                successAlert: true,
                resMessage: "Berhasil Mengirim Data",
            });
            setTimeout(() => {
                history.push({ pathname: this.state.returnTo });
            }, 2000);
        }
    };

    render() {
        const { profil, subProfil, action, subProfilCbtSoal } = this.state;
        let pageTitle = "Set Point Soal";

        return (
            <div className="wrapper">
                <LoaderModal isFetching={this.state.isFetching} />
                <Sidebar account={this.props.account} />
                <div id="content" style={{ paddingBottom: "50px" }}>
                    <Navbar title={pageTitle} />
                    {this.loadAlert()}
                    {this.state.missingContext ? (
                        <Alert variant="warning">
                            Pilih profil dan sub-profil terlebih dahulu untuk mengatur poin soal.
                            <div><Button onClick={() => history.push("/mgttoo")}>Buka profil Tryout</Button>{" "}
                            <Button onClick={() => history.push("/mgtsbmptn")}>Buka profil SBMPTN</Button></div>
                        </Alert>
                    ) : <Form onSubmit={this.handleSubmit}>
                        <Row style={{ marginBottom: 20 }}>
                            <Col>
                                Profil : <b>{this.state.profil.namaProfil}</b>
                            </Col>
                            <Col style={{ textAlign: "right" }}>
                                Sub-Profil : <b>{this.state.subProfil.namaMapel}</b>
                            </Col>
                        </Row>

                        <table className="table table-stripped table-hover">
                            <thead>
                                <tr>
                                    <td width={"5%"}>No.</td>
                                    <td>Pertanyaan</td>
                                    <td width={"10%"}>Bobot</td>
                                    <td width={"15%"}>Poin</td>
                                </tr>
                            </thead>
                            <tbody>
                                {subProfilCbtSoal.map((item, index) => {
                                    return (
                                        <tr key={index}>
                                            <td>
                                                <p>{index + 1}.</p>
                                            </td>
                                            <td>
                                                <span dangerouslySetInnerHTML={{ __html: item.pertanyaan }}></span>
                                            </td>
                                            <td>
                                                <p>{item.bobot}</p>
                                            </td>
                                            <td>
                                                <input
                                                    type="number"
                                                    min="0"
                                                    max="100"
                                                    maxLength="3"
                                                    name={"#_" + item.idBankSoal + "_" + item.idCbtSoalHub + "_" + item.poinSoal}
                                                    defaultValue={item.poinSoal}
                                                    className="form-control"
                                                    onChange={this.handleOnChangeNilai}
                                                />
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                        <hr />
                        <Button style={{ float: "right" }} type="submit" variant="primary">
                            Simpan
                        </Button>
                    </Form>}
                </div>
            </div>
        );
    }

    loadAlert = () => {
        const { alertShow, successAlert } = this.state;
        if (alertShow) {
            return (
                <Alert variant="danger" onClose={() => this.setState({ alertShow: false })} dismissible>
                    <strong>{this.state.resMessage}</strong>
                </Alert>
            );
        }

        if (successAlert) {
            return (
                <Modal size="md" aria-labelledby="contained-modal-title-vcenter" centered show={successAlert} onHide={() => this.setState({ successAlert: false })}>
                    <Modal.Body>
                        <p style={{ textAlign: "center" }}>
                            <h4>{this.state.resMessage}</h4>
                            <br /> <br />
                            <Button variant="primary" onClick={() => history.push({ pathname: this.state.returnTo })}>
                                Oke
                            </Button>
                        </p>
                    </Modal.Body>
                </Modal>
            );
        }
    };
}

const mapStateToProps = (state) => {
    return {
        account: state.account,
    };
};

export default connect(mapStateToProps, { cekCookies })(SetPointSbmptn);
